// extracted by mini-css-extract-plugin
module.exports = {"timer":"_14615","item":"_18219","divider":"_16542","unit":"_14972"};